import { render, staticRenderFns } from "./PronosticoInforme.vue?vue&type=template&id=24062afd&"
import script from "./PronosticoInforme.vue?vue&type=script&lang=js&"
export * from "./PronosticoInforme.vue?vue&type=script&lang=js&"
import style0 from "./PronosticoInforme.vue?vue&type=style&index=0&id=24062afd&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports